module.exports = __webpack_public_path__ + "img/iot-scene-construction.37343e89.png";